module.exports = __webpack_public_path__ + "assets/img/21_903_big.30ec84e0.jpg";